module.exports = __webpack_public_path__ + "img/facebook.41829bf3.png";